import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  GET_MATCHCODES: {
    url: "gebruiker/matchcode/overview",
    method: "post",
  },

  SAVE_MATCHCODE: {
    url: "gebruiker/matchcode/save",
    method: "post",
  },
};

// GET / OVERVIEW
export const useMatchcodesData = () =>
  useApiFetcherSWR(API_ENDPOINT.GET_MATCHCODES);

// SAVE
export const useSaveMatchcode = () =>
  useApiFetcherSWR(API_ENDPOINT.SAVE_MATCHCODE);